import posts from "../content/posts.json";
import { PostGrid } from "../components/PostGrid";

export const Blog = () => (
  <>
    <header className="page-header">
      <h1>Blog</h1>
      <p className="tagline">Everything I've been building, playing, and figuring out</p>
    </header>
    <PostGrid posts={posts} />
  </>
);
